import React from "react";
import { NavLink } from "polyrouter";
import { useTranslation } from "utilities/i18n";
import { FeatureFlagEnabled, useFeatureFlagWithTenant } from "elements";
import { Guard } from "TsRoleGuards";

export const DiagnosticsNav: React.FC<{
  isLogDownloadSupported: boolean;
  isPcapDownloadSupported: boolean;
  isPolyOSDevice: boolean;
  hasRelays: boolean;
  tenantId: string | undefined;
}> = ({
  isLogDownloadSupported,
  isPolyOSDevice,
  isPcapDownloadSupported,
  hasRelays,
  tenantId
}) => {
  const { t } = useTranslation();

  const [isRelayEnabled] = useFeatureFlagWithTenant("EDGE_RELAY");

  return (
    <ul className="menu router sub scroll" data-testid="diagnostics-nav">
      <li className="pl-1">
        <NavLink nest to="/device-information">
          {t("DEVICE_INFORMATION")}
        </NavLink>
      </li>
      <Guard requirement="access:device:logs">
        {isLogDownloadSupported && (
          <FeatureFlagEnabled feature="DOWNLOAD_LOGS">
            <li className="active pl-1">
              <NavLink nest to="/diagnostics">
                {t("DIAGNOSTICS")}
              </NavLink>
            </li>
          </FeatureFlagEnabled>
        )}
        {isPcapDownloadSupported && (
          <FeatureFlagEnabled feature="DOWNLOADING_PCAP">
            <li className="active pl-1">
              <NavLink nest to="/pcap">
                {t("PCAP")}
              </NavLink>
            </li>
          </FeatureFlagEnabled>
        )}
        {isPcapDownloadSupported && hasRelays && isRelayEnabled && (
          <li className="active pl-1">
            <NavLink nest to="/screen-capture">
              {t("SCREEN_CAPTURE")}
            </NavLink>
          </li>
        )}
      </Guard>
    </ul>
  );
};
